import React from 'react';

import styles from './styles.css';

const TheFormula = () => {
  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        <h3 className={styles.formula}>
          <span className={styles.bracket}>{'{'}</span>B + A + S + K =&nbsp;
          <strong>PQ</strong>
          <span className={styles.bracket}>{'}'}</span>
        </h3>
      </div>
    </div>
  );
};

export default TheFormula;



// WEBPACK FOOTER //
// ./src/components/TheFormula/index.js